import { useMemo } from 'react';
import type {
  PlatformInfo,
} from './types/use-platform-types';

export function getPlatformInfo(): PlatformInfo {
  if (typeof navigator === 'undefined') {
    return { isIos: false, isIosSafari: false, isAndroid: false, isMobile: false };
  }

  const ua = navigator.userAgent;

  // iPadOS 13+ identifies as desktop Safari but has touch — detect via maxTouchPoints.
  const isIpadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  const isIos = /iPad|iPhone|iPod/.test(ua) || isIpadOS;
  const isAndroid = /Android/.test(ua);
  // Chrome / Edge / FxIOS still report Safari in the UA; exclude them.
  const isIosSafari = isIos && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  const isMobile = isIos || isAndroid;

  return { isIos, isIosSafari, isAndroid, isMobile };
}

export function usePlatformInfo(): PlatformInfo {
  return useMemo(() => getPlatformInfo(), []);
}
